import { useEffect, useState } from "react";
import { language } from "../languages/tr";

function useLocale() {
  const locale = language.datePickerlang;
  const [localeData, setLocaleData] = useState(null);
  useEffect(() => {
    import(`date-fns/locale/${locale}/index.js`)
      .then((module) => setLocaleData(module.default))
      .catch((error) =>
        console.error(`Failed to load locale: ${locale}`, error)
      );
  }, [locale]);

  return localeData;
}

export default useLocale;
